<div class="dialog-container">
  <div class="dialog-header">
    <div class="heading text-type-2">Add contractor</div>
    <mat-icon class="close-icon" (click)="onCancel()">close</mat-icon>
  </div>
  <form>
    <app-dropdown
      [enableSearch]="subContractorOptions.length >= 10"
      [error]="errorMessages['sub_contractor']"
      [options]="subContractorOptions"
      [parentFormGroup]="form"
      class="mb-[20px]"
      controlName="sub_contractor"
      label="Contractor"
    />
    @for (field of contractorFormFields; track field) {
      @if (field.display_order === 1) {
        <ng-container [ngSwitch]="field.componentType || field.type">
          <app-text-input
            *ngSwitchCase="'string'"
            [controlName]="field.name"
            [label]="field.label"
            [parentFormGroup]="form"
            class="mb-[20px]"
          />
          <app-number-input
            *ngSwitchCase="'number'"
            [controlName]="field.name"
            [label]="field.label"
            [parentFormGroup]="form"
            class="mb-[20px]"
          />
          <div
            *ngSwitchCase="'boolean'"
            class="flex flex-row justify-between items-center gap-[20px] w-full mb-[40px]"
          >
            <div class="boolean-label text-type-13">
              {{ field.label }}
            </div>
            <mat-slide-toggle
              [checked]="form?.controls?.[field.name]?.value"
              (change)="form?.controls?.[field.name]?.setValue($event.checked)"
              [disableRipple]="false"
              class="slide-toggle-btn"
              color="primary"
            />
          </div>
        </ng-container>
      }
    }
    <div class="flex flex-row justify-center items-center mb-[20px] gap-[20px] w-full">
      @for (field of contractorFormFields; track field) {
        @if (field.display_order === 2 || field.display_order === 3) {
          <ng-container [ngSwitch]="field.componentType || field.type">
            <app-time-select
              *ngSwitchCase="'time'"
              [amPmControlName]="field.name + '_am_pm'"
              [controlName]="field.name"
              [label]="field.label"
              [parentFormGroup]="form"
              [timePeriodControlName]="field.name + '_timePeriod'"
              class="w-1/2"
            />
            <app-text-input
              *ngSwitchCase="'string'"
              [controlName]="field.name"
              [label]="field.label"
              [parentFormGroup]="form"
              class="w-1/2"
            />
            <app-number-input
              *ngSwitchCase="'number'"
              [controlName]="field.name"
              [label]="field.label"
              [parentFormGroup]="form"
              class="w-1/2"
            />
          </ng-container>
        }
      }
    </div>
    @for (field of contractorFormFields; track field) {
      @if (field.display_order !== 1 && field.display_order !== 2 && field.display_order !== 3) {
        <ng-container [ngSwitch]="field.componentType || field.type">
          <app-text-input
            *ngSwitchCase="'string'"
            [controlName]="field.name"
            [label]="field.label"
            [parentFormGroup]="form"
            class="mb-[20px]"
          />
          <app-number-input
            *ngSwitchCase="'number'"
            [controlName]="field.name"
            [label]="field.label"
            [parentFormGroup]="form"
            class="mb-[20px]"
          />
          <app-dropdown
            *ngSwitchCase="'dropdown'"
            [controlName]="field.name"
            [enableSearch]="true"
            [label]="field.label"
            [options]="field?.ui_config?.pick_list_values || []"
            [parentFormGroup]="form"
            [sentenceCase]="true"
            class="mb-[20px]"
          />
          <app-text-area
            *ngSwitchCase="'textarea'"
            [controlName]="field.name"
            [label]="field.label"
            [parentFormGroup]="form"
            class="mb-[20px]"
          />
          <app-time-select
            *ngSwitchCase="'time'"
            [amPmControlName]="field.name + '_am_pm'"
            [controlName]="field.name"
            [label]="field.label"
            [parentFormGroup]="form"
            [timePeriodControlName]="field.name + '_timePeriod'"
            class="mb-[20px]"
          />
          <div
            *ngSwitchCase="'boolean'"
            class="flex flex-row justify-between items-center gap-[20px] w-full mb-[40px]"
          >
            <div class="boolean-label text-type-13">
              {{ field.label }}
            </div>
            <mat-slide-toggle
              [checked]="form?.controls?.[field.name]?.value"
              (change)="form?.controls?.[field.name]?.setValue($event.checked)"
              [disableRipple]="false"
              class="slide-toggle-btn"
              color="primary"
            />
          </div>
        </ng-container>
      }
    }
    <app-primary-button class="submit-btn" (handleClick)="onSubmit()">Submit</app-primary-button>
  </form>
</div>
